import api, { ApiReturn, GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadMovimentacaoTipoDto, CreateMovimentacaoTipoDto, UpdateMovimentacaoTipoDto } from '@/api.types';

/**
 * Lista tipos de movimentação para selects (sem restrição de permissão).
 * @returns Lista de tipos de movimentação com id e descricao.
 */
export async function ListarOpcoesMovimentacaoTipo(): Promise<ApiReturn<ReadMovimentacaoTipoDto>> {
  return api
    .get(`${Endpoints.MOVIMENTACAOTIPO}/opcoes/lista`)
    .then((response) => {
      return response.data as ApiReturn<ReadMovimentacaoTipoDto>;
    })
    .catch((error) => {
      console.error('Erro ao listar opções de tipos de movimentação:', error);
      return { objects: [], count: 0 };
    });
}

export async function LerTipoMovimentacoes(
  skip: number,
  take: number,
  nucleo: boolean = false,
  descricao: string = '',
) {
  let where = `movimentacao_tipo.nucleo = ${nucleo}`;
  const termo = descricao.trim();
  if (termo) {
    const safe = termo.replace(/'/g, "''");
    where += ` and movimentacao_tipo.descricao ilike '%${safe}%'`;
  }

  return api
    .get(Endpoints.MOVIMENTACAOTIPO, {
      params: { skip: skip, take: take, where },
    })
    .then((response) => {
      return GetApiReturn<ReadMovimentacaoTipoDto>(
        response.data as Array<ReadMovimentacaoTipoDto>,
      );
    })
    .catch((error) => {
      ValidateAxiosError<ReadMovimentacaoTipoDto>(error, 'Falha ao listar objetos.');
      return GetApiReturnError<ReadMovimentacaoTipoDto>();
    });
}

export async function LerTipoMovimentacao(id: number) {
  return api
    .get<ReadMovimentacaoTipoDto>(Endpoints.MOVIMENTACAOTIPO + '/' + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadMovimentacaoTipoDto>(
        error,
        'Falha ao bucar objeto.' + id,
      );
    });
}

export async function AtualizarTipoMovimentacao(tipo: CreateMovimentacaoTipoDto | UpdateMovimentacaoTipoDto) {
  if (tipo.id !== null && tipo.id != undefined && tipo.id > 0) {
    return api
      .put(Endpoints.MOVIMENTACAOTIPO + '/' + tipo.id, tipo as UpdateMovimentacaoTipoDto)
      .then(() => {
        return 'Tipo ' + (tipo as ReadMovimentacaoTipoDto).descricao + ' atualizada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(error, 'Falha ao atualizar objeto.');
      });
  } else {
    return api
      .post(Endpoints.MOVIMENTACAOTIPO, tipo as CreateMovimentacaoTipoDto)
      .then(() => {
        return 'Tipo ' + (tipo as CreateMovimentacaoTipoDto).descricao + ' cadastrada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(error, 'Falha ao cadastrar objeto.');
      });
  }
}

export async function ExcluirTipoMovimentacao(id: number) {
  return api
    .delete(Endpoints.MOVIMENTACAOTIPO + '/' + id)
    .then(() => {
      return 'Tipo removido.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover objeto.');
    });
}
